import { Component, Input, OnInit } from '@angular/core';
import { ModalBaseComponent } from '../add-or-edit-org-modal/modal-base.component';
import { OnboardingStatus } from '../data/onboarding-status';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../data/data.service';

@Component({
  selector: 'app-onboarding-notification-modal',
  templateUrl: './onboarding-notification-modal.component.html',
  styleUrls: ['./onboarding-notification-modal.component.css']
})
export class OnboardingNotificationModalComponent extends ModalBaseComponent<OnboardingStatus> implements OnInit {

  constructor(modalService: NgbModal, dataService: DataService) { super(modalService, dataService); }

  @Input() orgId: number;
  userEmailAddress: string;

  userRosteringStatus: number;
  userDevicesStatus: number;
  userTrainingStatus: number;

  initializeNewData(): void {
    throw new Error('Method not implemented.');
  }
  isInputValid(): boolean {
    throw new Error('Method not implemented.');
  }
  saveEdit(): void {
    throw new Error('Method not implemented.');
  }
  saveNew(): void {
    throw new Error('Method not implemented.');
  }

  ngOnInit() {
    this.dataService.getOnboardingStatus(this.orgId).subscribe(status => {
      this.data = status;
      this.userEmailAddress = JSON.parse(localStorage['session']).Email;
      this.checkForIncompleteSteps();
    });
  }

  checkForIncompleteSteps() {
    this.userRosteringStatus = this.data.RosteringAccount == this.userEmailAddress ? 
      this.data.RosteringProgress || 0
      : -1;
    
    this.userDevicesStatus = this.data.DevicesAccount == this.userEmailAddress ? 
      this.data.DevicesProgress || 0
      : -1;
      
    this.userTrainingStatus = this.data.TrainingAccount == this.userEmailAddress ? 
      this.data.TrainingProgress || 0
      : -1;

    if (this.userStepActive(this.userRosteringStatus) 
      || this.userStepActive(this.userDevicesStatus)
      || this.userStepActive(this.userTrainingStatus))
      this.showModal();
  }

  showModal() {
    this.modalHeader = "Onboarding step waiting";
    this.open(this.content);
  }

  completeStep() {
    if (this.userRosteringStatus > -1) this.data.RosteringProgress = 2;
    if (this.userDevicesStatus > -1) this.data.DevicesProgress = 2;
    if (this.userTrainingStatus > -1) this.data.TrainingProgress = 2;

    this.dataService.setOnboardingStatus(this.orgId, this.data).subscribe(o => {
      this.modal.close();
    });
  }

  userStepActive(status: number): boolean {
    return -1 < status && 2 > status;
  }

}
